/* eslint-disable */

export enum PaymentPullState {
  AUTH_PENDING = "AUTH_PENDING",
  AUTH_FAILED = "AUTH_FAILED",
  AUTHORIZED = "AUTHORIZED",
  /**
   * WAITING_FOR_CAPTURE - This is considered a successful pull for CAPTURING or PULLING_REFUND state, but this might fail
   * later asynchronously. This state is used only for ACH pulls and corresponds to the Teller money
   * transfer states: STAGED, PENDING, or SENT.
   */
  WAITING_FOR_CAPTURE = "WAITING_FOR_CAPTURE",
  /**
   * CAPTURED - Pull captured.
   * If this state is used for ACH pulls, then it corresponds to the Teller money transfer states:
   * TENTATIVELY_SUCCEEDED or SUCCEEDED.
   */
  CAPTURED = "CAPTURED",
  REFUNDED = "REFUNDED",
  /** PULL_FAILED - Pull failed. See the reason in PaymentPull.failure_reason. */
  PULL_FAILED = "PULL_FAILED",
  /**
   * PULL_FAILED_UNSUPPORTED - The mechanism does not support this payment.
   * Deprecated: This will be replaced soon by PULL_FAILED with an appropriate failure_reason.
   *
   * @deprecated
   */
  PULL_FAILED_UNSUPPORTED = "PULL_FAILED_UNSUPPORTED",
  /** PULL_FAILED_RETRY_LATER - The mechanism should be retried before failing or proceeding to another mechanism */
  PULL_FAILED_RETRY_LATER = "PULL_FAILED_RETRY_LATER",
  /**
   * CHARGEBACK_REPORTED - When a chargeback is reported, the captured funds may be returned to the sender through a
   * separate, offline mechanism. We must not refund these pulls otherwise the sender will get
   * the money back twice.
   */
  CHARGEBACK_REPORTED = "CHARGEBACK_REPORTED",
}
